import { PageHeader } from "@/CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import { BagsList } from "./BagsList";

export const MakkahBags = () => {
    const { t } = useTranslation();
    return (
        <Stack gap={3}>
            <PageHeader title={t("BAGS")} />
            <Container fluid>
                <BagsList />
            </Container>
        </Stack>
    );
};